import React from 'react';
import axios from 'axios';
import config from '../../../../../../config/config';
import { getUserSession } from '../../../functions/Session';
import Toast from '../../Toast/Toast';


export class FileUpload extends React.Component {

    constructor(props) {
        super(props);
        const fileExtension = this.props.file.split('.').pop();
        const extensionImages = ['jpeg', 'jpg', 'png'];
        const isImage = extensionImages.includes(fileExtension.toLowerCase());
        this.state = {
            value: '',
            file: this.props.file ? this.props.file : '',
            fileExtension: fileExtension,
            isImage: isImage,
            extensionImages: extensionImages,
            link: this.props.file ? config.endpoints.backend + this.props.file : '', 
        }
        this.onUpload = this.onUpload.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = value => {
        const session = getUserSession();
        if(this.props.disabled){
            Toast.error(`Upload de arquivo desabilitado.`);
            return;
        } else if (value.target.files.length > 0) {
            const size = value.target.files[0].size/1000000;
            const limitSize = this.props.limitFileSize;
            if(size>limitSize){
                Toast.error(`O arquivo não pode ser maior que ${limitSize} MB(s).`);
                return;
            }
            const data = new FormData()
            const token = session.token;
            const path = config.endpoints.backend + 'core/fileupload/upload';
            const configHeader = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };
            data.append('file', value.target.files[0]);
            data.append('token', token);
            data.append('path', this.props.path);

            this.beforeUpload();
            axios.post(path, data, configHeader).then((res) => {

                const file = res.data.files[0];
                this.onUpload(this.props.name, file);
                const fileExtension = file.split('.').pop();
                const isImage = this.state.extensionImages.includes(fileExtension.toLowerCase());
                this.setState({
                    value: '',
                    file: file,
                    fileExtension: fileExtension,
                    isImage: isImage,
                    link: config.endpoints.backend + file
                })
            }).catch(error => console.error(error));
        }
    }

    onUpload = (inputName, file) => {
        this.props.onUpload(inputName, file);
    }

    beforeUpload = () => {
        this.props.beforeUpload();
    }

    clickRemove = async () => {
        this.setState({
            file: ''
        });
        this.props.onRemove(this.props.name, '');
    }

    render() {
        return (
            <div style={{ marginTop: 10 }}>
                {!this.state.file && !this.props.disabled && (
                    <div>
                        <label className="btn btn-primary" >
                            <input
                                id="my-file-selector"
                                className="d-none"
                                type="file"
                                name={this.props.name}
                                onChange={this.handleChange}
                                accept={this.props.accept}
                                value={this.state.value}
                                autoFocus={this.props.autoFocus?true:false}
                            />
                            {this.props.titleButton}
                        </label>
                        {this.props.error && (
                            <div
                                class="error invalid-feedback"
                                style={{ display: 'inline',width:'100%',marginLeft:'10px' }}>
                                {this.props.error}
                            </div>
                        )}
                    </div>
                )}
                {this.state.file && !this.state.isImage && (
                    <div>
                        <a target="a_blank" href={this.state.link}>Download</a>
                        &nbsp;&nbsp;<span onClick={this.clickRemove} className="required" style={{ cursor: 'pointer' }}><strong>X</strong></span>
                        {this.props.error && (
                            <div
                                class="error invalid-feedback"
                                style={{ display: 'inline',width:'100%',marginLeft:'10px' }}>
                                {this.props.error}
                            </div>
                        )}
                    </div>
                )}
                {this.state.file && this.state.isImage && (
                    <div style={{ width: "100px" }}>
                        <a target="a_blank" href={this.state.link}>
                            <img style={{ width: '100px' }} src={this.state.link} />
                        </a>
                        {!this.props.disabled && (
                        <div onClick={this.clickRemove} className="required" style={{ cursor: 'pointer', textAlign: 'center', marginTop: '5px' }}>remover</div>
                        )}
                        {this.props.error && (
                            <div
                                class="error invalid-feedback"
                                style={{ display: 'inline',width:'100%',marginLeft:'10px' }}>
                                {this.props.error}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

FileUpload.defaultProps = {
    onChange: () => { },
    onUpload: () => { },
    beforeUpload: 0,
    path: '',
    accept: "media_type",
    titleButton: 'Anexar',
    file: '',
    limitFileSize: 5,
    disabled: false
}
export default FileUpload;
